import { useListContext } from 'react-admin';

export const PostTotal = () => {
    const { total, isLoading } = useListContext();
    return <div>{total}</div>;
};
